import { css } from "@emotion/react";

export const styLangSelectorWrapper = css`
  position: fixed;

  width: 26px;
  height: 26px;
  background-color: #a99d87;
  bottom: 20px;
  transform: translate(-50%, -50%) translate(26px, 0px);
  border-radius: 4px;
  border: 2px solid #a99d87;
  text-align: center;
  line-height: 26px;
  color: #f9f9f9;
  z-index: 2;
  cursor: pointer;
  font-size: 12px;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-transform: uppercase;
  }

  @media (min-width: 350px) {
    width: 32px;
    height: 32px;
    line-height: 32px;
    transform: translate(-50%, -50%) translate(30px, 0px);

    > .icon {
      width: 16px;
      height: 16px;
    }
  }
`;
